module.exports = __webpack_public_path__ + "static/img/login_bg2.787a20b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login_bg2.jpg
// module id = bHns
// module chunks = 128